import { reducedMotion } from './motion.js';

const REVEAL_SELECTOR = '[data-reveal]';
const SKIP = new Set(['load', 'media']);
const REVEALED_CLASS = 'is-revealed';
const ROOT_CLASS = 'has-reveal';

export default class Reveal {
	constructor(root = document) {
		this.root = root;
		this.observer = null;
		this.onIntersect = this.onIntersect.bind(this);
		this.observe(root);
	}

	observe(root = this.root) {
		if (!root?.querySelectorAll) return;

		this.revealMedia(root);

		const targets = Array.from(root.querySelectorAll(REVEAL_SELECTOR)).filter(
			(el) => !SKIP.has(el.getAttribute('data-reveal')) && !el.classList.contains(REVEALED_CLASS)
		);

		if (!targets.length) return;

		if (reducedMotion() || !('IntersectionObserver' in window)) {
			targets.forEach((el) => el.classList.add(REVEALED_CLASS));
			return;
		}

		document.documentElement.classList.add(ROOT_CLASS);

		if (!this.observer) {
			this.observer = new IntersectionObserver(this.onIntersect, {
				rootMargin: '0px 0px -8% 0px',
				threshold: 0.01,
			});
		}

		targets.forEach((el) => this.observer.observe(el));
	}

	revealMedia(root) {
		const medias = Array.from(root.querySelectorAll('[data-reveal="media"]')).filter(
			(el) => !el.classList.contains(REVEALED_CLASS)
		);

		if (!medias.length) return;

		if (reducedMotion()) {
			medias.forEach((el) => el.classList.add(REVEALED_CLASS));
			return;
		}

		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				medias.forEach((el) => el.classList.add(REVEALED_CLASS));
			});
		});
	}

	onIntersect(entries) {
		for (const entry of entries) {
			if (!entry.isIntersecting) continue;

			entry.target.classList.add(REVEALED_CLASS);
			this.observer.unobserve(entry.target);
		}
	}

	destroy() {
		if (this.observer) {
			this.observer.disconnect();
			this.observer = null;
		}
	}
}
